import styled from 'styled-components';

export const CityNameFilterGroup = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    column-gap: 12px;
    color: #33A7AE;
    flex-direction: column;
`;

export const BrowseNameWrap = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    column-gap: 12px;
    color: #01606F;

    @media screen and (max-width: 575px){
        flex-direction: column;
    }
`;
export const BrowseNameTitle = styled.div`
    font-size: 18px;
    font-weight: 600;
    font-family: "Jost", sans-serif;
    line-height: 26px;
    width: 140px;
    min-width: 140px;

    &.browse-name-title-black{
        width: 100%;
        min-width: max-content;
        color: #333333;
        font-size: 20px;
        font-family: 'Jost', sasn-serif;
        font-weight: 700;
        line-height: 30px;
        max-width: max-content;
    }
`;
export const BrowseStateCityWrap = styled.div`
    width: 100%;
    margin: 70px 0 50px;

    @media screen and (max-width: 991px){
        margin: 40px 0px;
    }
    @media screen and (max-width: 767px){
        margin: 30px 0px;
    }
`;

export const BrowseNameDash = styled.div`
    font-size: 20px;
    font-family: "Jost", sans-serif;
    font-weight: 400;
    line-height: 26px;

    @media screen and (max-width: 575px){
        display: none;
    }
`;

export const BrowseButtonGroup = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    column-gap: 3px;
    flex-wrap: wrap;
    row-gap: 3px;

    @media screen and (max-width: 991px){
        overflow-x: scroll;
    }

    @media screen and (max-width: 575px){
        margin-top: 10px;
    }
`;

export const BrowseButton = styled.a`
    min-width: max-content;  
    color: #01606F;
    font-size: 18px;
    font-weight: 400;
    font-family: "Jost", sans-serif;
    line-height: 26px;
    border: none;
    background: transparent;
    padding: 0 4px;
    background: transparent;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    &:hover{
        color: #F7931E;
    }

    &.browse-button-link-blk{
        color: #01606F;
        font-size: 20px;
        font-weight: 700;
        font-family: "Jost", sans-serif;
        line-height: 30px;
        background: transparent;
        transition: all 0.2s ease-in-out;
        cursor: pointer;
        &:hover{
            color: #F7931E;
        }
    }
`;



export const BrowseStateCityTitle = styled.h2`
    color: #333333;
    font-size: 20px;
    font-family: "Jost", sans-serif;
    font-weight: 700;
    line-height: 30px;
    margin-bottom: 20px;
     &.browse-state-title{
        display:none;
     }
`;

export const CityNameFilterWrap = styled.div`
    width: 100%;
`;

export const CityNameFilterTitle = styled.h2`
    color: #333333;
    font-size: 30px;
    font-family: "Jost", sans-serif;
    font-weight: 600;
    line-height: 44px;
    margin-bottom: 20px;
`;

export const CityNameFilterText = styled.p`
    color: #333333;
    font-size: 18px;
    font-family: "Jost", sans-serif;
    font-weight: 400;
    line-height: 22px;
    margin-bottom: 30px;
`;

export const CityNameFilterButtonGroup = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    column-gap: 30px;
    color: #000;
    
    margin-bottom: 20px;
`;

export const CityNameButton = styled.a`
    text-decoration: none;
    color: #01606F;
    font-size: 20px;
    font-family: "Jost", sans-serif;
    font-weight: 700;
    line-height: 30px;
    position: relative;
    transition: all 0.5s ease-in-out;
    cursor: pointer;
 
    &:hover{
        color: #000000;
    }
    
    &::before{
        content: '';
        position: absolute;
        width: 3px;
        height: 20px;
        background: #000;
        margin: auto;
        top: 4px;
        right: -17px;
    }

    &:last-child{
        &::before{
            display: none;
        }
    }
`;